import { Settings2 } from 'lucide-react';
import { Button } from './ui/button';
import { Popover, PopoverContent, PopoverTrigger } from './ui/popover';
import { Checkbox } from './ui/checkbox';
import { Label } from './ui/label';

/**
 * ColumnToggle — gear icon popover for toggling table column visibility.
 * @param {Object} columns - { key: { label, visible } }
 * @param {Function} onToggle - (key, visible) => void
 */
export function ColumnToggle({ columns, onToggle, onReset }) {
  const entries = Object.entries(columns);
  const visibleCount = entries.filter(([, c]) => c.visible).length;
  const allVisible = visibleCount === entries.length;

  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button variant="ghost" size="icon" className="h-7 w-7" data-testid="column-toggle-btn" aria-label="Toggle columns">
          <Settings2 className="w-3.5 h-3.5 text-muted-foreground" />
        </Button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-52 p-3" data-testid="column-toggle-popover">
        <p className="text-xs font-semibold text-muted-foreground mb-2 uppercase tracking-wide">Columns</p>
        <div className="space-y-2">
          {entries.map(([key, col]) => {
            const isLastVisible = col.visible && visibleCount <= 1;
            return (
              <label key={key} className="flex items-center gap-2 cursor-pointer">
                <Checkbox
                  checked={col.visible}
                  disabled={isLastVisible}
                  onCheckedChange={(checked) => onToggle(key, !!checked)}
                  data-testid={`col-toggle-${key}`}
                />
                <Label className="text-sm font-normal cursor-pointer">{col.label}</Label>
              </label>
            );
          })}
        </div>
        {!allVisible && onReset && (
          <button
            type="button"
            onClick={onReset}
            className="mt-3 pt-2 border-t w-full text-xs text-muted-foreground hover:text-foreground transition-colors text-left cursor-pointer"
            data-testid="column-reset-btn"
          >
            Reset to Default
          </button>
        )}
      </PopoverContent>
    </Popover>
  );
}
